<template>
	<div class="expressions" >
		<v-snackbar v-model="snackbar" :timeout="4000" bottom right :color="color">
			<span>{{ message }}</span>
		</v-snackbar>
		<v-container>
			<v-layout column>
				<div v-if="view == 'default'">
					<v-tabs show-arrows v-model="expressionTab" class="mt-5">
						<v-tabs-slider color="primary"></v-tabs-slider>

						<v-tab @click="activeTab = 'submitted'">
							<div class="text-none primary--text">
								Submitted ({{ submittedExpressionPagination.total }})
							</div>
						</v-tab>
						<v-tab @click="activeTab = 'review'">
							<div class="text-none primary--text">
								Review ({{ reviewExpressionPagination.total }})
							</div>
						</v-tab>
						<v-tab @click="activeTab = 'rejected'">
							<div class="text-none primary--text">
								Rejected ({{ rejectedExpressionPagination.total }})
							</div>
						</v-tab>
						<v-tab @click="activeTab = 'shortlisted'">
							<div class="text-none primary--text">
								Shortlisted ({{ shortlistedExpressionPagination.total }})
							</div>
						</v-tab>
					</v-tabs>

					<div v-if="activeTab == 'submitted'">
						<v-card outlined class="mt-5 pa-3" style="border-radius: 25px;">
							<v-flex xs12 class="mt-10 mb-2">
								<div class="mx-5">
									<v-layout row wrap>
										<v-flex xs12 md4>
											<h1>Submitted Expressions</h1>
										</v-flex>
										<v-flex xs12 md4>
											<div class="pa-1">
												<v-text-field class="text_field header" outlined dense label="Search"
													append-icon="mdi-undo-variant" @click:append="resetSearch()"
													v-on:keyup.enter="submittedSearch" v-model="searchTerm"
													@input="enableSearch()"></v-text-field>
											</div>

										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="secondary white--text text-none" depressed block
													@click="submittedSearch" :loading="searchLoader"
													:disabled="searchButtonDisabled">
													Search
													<v-icon right>mdi-magnify</v-icon>
												</v-btn>
											</div>
										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="primary white--text text-none" depressed block
													@click="csvDownload('submittedExpressions')" :loading="csvLoading">
													Download CSV
													<v-icon right>mdi-microsoft-excel</v-icon>
												</v-btn>
											</div>
										</v-flex>
									</v-layout>
								</div>
							</v-flex>
							<div class="mx-5 mt-9">
								<v-progress-linear v-if="submittedExpressionLoader" height="1" indeterminate
									color="primary"></v-progress-linear>
							</div>
							<v-divider class="mx-5"></v-divider>
							<v-flex xs12 class="mt-5">
								<div v-if="submittedExpressions.length == 0">
									<v-card elevation="0">
										<v-layout row wrap>
											<v-flex xs12 md1>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center">
															<v-icon large class="text--text">
																mdi-alert-circle-outline
															</v-icon>
														</v-col>
													</v-row>
												</v-container>
											</v-flex>
											<v-flex xs12 md11>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center"> No Expression Found </v-col>
													</v-row>
												</v-container>
											</v-flex>
										</v-layout>
									</v-card>
								</div>
								<div v-else>
									<div class="hidden-sm-and-down">
										<v-card elevation="0" class="pa-2">
											<v-simple-table>
												<template v-slot:default>
													<thead class="header">
														<tr class="tableHeader">
															<th class="text-left text--text">#</th>
															<th class="text-left text--text">Principal Founder</th>
															<th class="text-left text--text">Venture</th>
															<th class="text-left text--text">Age</th>
                                                            <th class="text-left text--text">Email</th>
															<th class="text-left text--text">Date Added</th>
															<th class="text-right text--text">Actions</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(item, index) in submittedExpressions" :key="item.id">
															<td>
																{{ index + 1 }}
															</td>
															<td>{{ item.first_name }} {{ item.middle_name }} {{ item.last_name }}</td>
															<td>{{ item.startup_name }}</td>
															<td>
																<div v-if="item.age_group">
																	{{ item.age_group.name }}
																</div>
																<div v-else>
																	N/A
																</div>
															</td>
                                                            <td>{{ item.email }}</td>
															<td>
																{{ item.created_at | moment("DD/MM/YYYY - hh:mm a") }}
															</td>
															<td>
																<div align="right">
																	<v-tooltip top >
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 universal--text"
																				@click="showExpression(item)">
																				<v-icon small> mdi-eye </v-icon>
																			</v-btn>
																		</template>
																		<span>View</span>
																	</v-tooltip>

																	<v-tooltip top v-if="$can('expression_archive')">
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 error--text"
																				@click="deleteExpression(item)"
																				:loading="loading && expressionIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-delete </v-icon>
																			</v-btn>
																		</template>
																		<span>delete</span>
																	</v-tooltip>

																	<v-tooltip top>
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 green--text"
																				@click="expressionReview(item, 'reviewStage', 'up')"
																				:loading="upgradeLoading && expressionIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-arrow-right
																				</v-icon>
																			</v-btn>
																		</template>
																		<span>Send For Review</span>
																	</v-tooltip>
																	<v-tooltip top v-if="$can('log_view')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 purple--text"
																				@click="viewLog(item)" v-bind="attrs"
																				v-on="on">
																				<v-icon small> mdi-script-text </v-icon>
																			</v-btn>
																		</template>
																		<span>Log</span>
																	</v-tooltip>

																</div>
															</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>

									</div>
									<div class="hidden-md-and-up">
										<v-layout column>
											<template v-for="(expression, index) in submittedExpressions">
												<div :key="index">
													<v-flex xs12 class="mb-2">
														<v-card elevation="0">
															<div class="pa-5">
																<v-layout column>
																	<v-flex xs12>
																		<v-layout row wrap>
																			<v-flex xs11>
																				<div class="title primary--text ml-3">
																					<b>{{ expression.startup_name }} </b>
																				</div>
																			</v-flex>
																			<v-flex xs1>
																				<v-btn depressed class="red--text" :loading="loading && expressionIndex == expression.id" icon @click="deleteExpression(expression)" v-if="$can('expression_archive')">
																					<v-icon> mdi-delete </v-icon>
																				</v-btn>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																	<v-divider class="mt-2"></v-divider>
																	<v-flex xs12 class="mt-1">
																		<v-layout column>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Principal Founder</b>
																				</div>
																				<div>
																					{{ expression.first_name }} {{ expression.middle_name }} {{ expression.last_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Venture</b>
																				</div>
																				<div>
																					{{ expression.startup_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Age</b>
																				</div>
																				<div v-if="expression.age_group">
																					{{ expression.age_group.name }}
																				</div>
																				<div v-else>
																					N/A
																				</div>
																			</v-flex>
                                                                            <v-flex xs12 class="mt-1">
																				<div>
																					<b>Email</b>
																				</div>
																				<div>
																					{{ expression.email }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Date Added</b>
																				</div>
																				<div>
																					{{
																						expression.created_at
																						| moment("DD/MM/YYYY - hh:mm a")
																					}}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-5">
																				<v-layout row wrap>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn
																								
																								depressed class="
																								primary
																								text-none
																								white--text
																								" block @click="showExpression(expression)">View
																								<v-icon right> mdi-eye
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="green text-none white--text"
																								block
																								@click="expressionReview(expression, 'reviewStage', 'up')"
																								:loading="upgradeLoading && expressionIndex == expression.id"
																								>Send For Review
																								<v-icon right>
																									mdi-arrow-right
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn v-if="$can('log_view')"
																								depressed class="
                                                                                                purple
                                                                                                text-none
                                                                                                white--text
                                                                                                " block @click="viewLog(expression)">Log
																								<v-icon right>
																									mdi-script-text
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																				</v-layout>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																</v-layout>
															</div>
														</v-card>
													</v-flex>
												</div>
											</template>
										</v-layout>
									</div>
								</div>
							</v-flex>
						</v-card>

						<v-layout column class="mt-5">
							<v-flex xs12>
								<div align="center">
									<v-pagination v-if="length != 0" :length="submittedExpressionLength" total-visible="10"
										v-model="submittedExpressionPagination.current_page" @input="changeSubmittedExpressionPage()" circle>
									</v-pagination>
								</div>
							</v-flex>
							<v-flex xs12>
								<div v-if="length != 0" align="center" class="mt-5">
									<b class="primary--text">Total: </b>{{ submittedExpressionPagination.total | formatNumber }}
								</div>
							</v-flex>
						</v-layout>
					</div>
					<div v-if="activeTab == 'review'">
						<v-card outlined class="mt-5 pa-3" style="border-radius: 25px;">
							<v-flex xs12 class="mt-10 mb-2">
								<div class="mx-5">
									<v-layout row wrap>
										<v-flex xs12 md4>
											<h1>Review Expressions</h1>
										</v-flex>
										<v-flex xs12 md4>
											<div class="pa-1">
												<v-text-field class="text_field header" outlined dense label="Search"
													append-icon="mdi-undo-variant" @click:append="resetSearch()"
													v-on:keyup.enter="reviewSearch" v-model="searchTerm"
													@input="enableSearch()"></v-text-field>
											</div>

										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="secondary white--text text-none" depressed block
													@click="reviewSearch" :loading="searchLoader"
													:disabled="searchButtonDisabled">
													Search
													<v-icon right>mdi-magnify</v-icon>
												</v-btn>
											</div>
										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="primary white--text text-none" depressed block
													@click="csvDownload('reviewExpressions')" :loading="csvLoading">
													Download CSV
													<v-icon right>mdi-microsoft-excel</v-icon>
												</v-btn>												
											</div>
										</v-flex>
									</v-layout>
								</div>
							</v-flex>
							<div class="mx-5 mt-9">
								<v-progress-linear v-if="reviewExpressionLoader" height="1" indeterminate color="primary"></v-progress-linear>
							</div>
							<v-divider class="mx-5"></v-divider>
							<v-flex xs12 class="mt-5">
								<div v-if="reviewExpressions.length == 0">
									<v-card elevation="0">
										<v-layout row wrap>
											<v-flex xs12 md1>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center">
															<v-icon large class="primary--text">
																mdi-alert-circle-outline
															</v-icon>
														</v-col>
													</v-row>
												</v-container>
											</v-flex>
											<v-flex xs12 md11>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center"> No Expression Found </v-col>
													</v-row>
												</v-container>
											</v-flex>
										</v-layout>
									</v-card>
								</div>
								<div v-else>
									<div class="hidden-sm-and-down">
										<v-card elevation="0" class="pa-2">
											<v-simple-table>
												<template v-slot:default>
													<thead class="header">
														<tr class="tableHeader">
															<th class="text-left text--text">#</th>
															<th class="text-left text--text">Principal Founder</th>
															<th class="text-left text--text">Venture</th>
															<th class="text-left text--text">Age</th>
                                                            <th class="text-left text--text">Email</th>
															<th class="text-left text--text">Date Added</th>
															<th class="text-right text--text">Actions</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(item, index) in reviewExpressions" :key="item.id">
															<td>
																{{ index + 1 }}
															</td>
															<td>{{ item.first_name }} {{ item.middle_name }} {{ item.last_name }}</td>
															<td>{{ item.startup_name }}</td>
															<td>
																<div v-if="item.age_group">
																	{{ item.age_group.name }}
																</div>
																<div v-else>
																	N/A
																</div>
															</td>
                                                            <td>{{ item.email }}</td>
															<td>
																{{ item.created_at | moment("DD/MM/YYYY - hh:mm a") }}
															</td>															
															<td>
																<div align="right">
																	<v-tooltip top >
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 universal--text"
																				@click="showExpression(item)">
																				<v-icon small> mdi-eye </v-icon>
																			</v-btn>
																		</template>
																		<span>View</span>
																	</v-tooltip>
																	<!-- <v-tooltip top v-if="$can('expression_edit')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 success--text"
																				@click="editExpression(item)" v-bind="attrs"
																				v-on="on">
																				<v-icon small> mdi-pencil </v-icon>
																			</v-btn>
																		</template>
																		<span>Edit</span>
																	</v-tooltip> -->

																	<v-tooltip top v-if="$can('expression_archive')">
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 error--text"
																				@click="deleteExpression(item)"
																				:loading="loading && expressionIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-delete </v-icon>
																			</v-btn>
																		</template>
																		<span>delete</span>
																	</v-tooltip>

																	<v-tooltip top
																		>

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 red--text"
																				@click="expressionReview(item, 'rejectedStage', 'down')"
																				:loading="downgradeLoading && expressionIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-cancel
																				</v-icon>
																			</v-btn>
																		</template>
																		<span>Reject Expression</span>
																	</v-tooltip>
																	<v-tooltip top
																		>

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 green--text"
																				@click="expressionReview(item, 'shortlisted', 'up')"
																				:loading="upgradeLoading && expressionIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-arrow-right
																				</v-icon>
																			</v-btn>
																		</template>
																		<span>Shortlist Expression</span>
																	</v-tooltip>
																	<v-tooltip top v-if="$can('log_view')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 purple--text"
																				@click="viewLog(item)" v-bind="attrs"
																				v-on="on">
																				<v-icon small> mdi-script-text </v-icon>
																			</v-btn>
																		</template>
																		<span>Log</span>
																	</v-tooltip>

																</div>
															</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>

									</div>
									<div class="hidden-md-and-up">
										<v-layout column>

											<template v-for="(expression, index) in reviewExpressions">
												<div :key="index">
													<v-flex xs12 class="mb-2">
														<v-card elevation="0">
															<div class="pa-5">
																<v-layout column>
																	<v-flex xs12>
																		<v-layout row wrap>
																			<v-flex xs11>
																				<div class="title primary--text ml-3">
																					<b>{{ expression.startup_name }} </b>
																				</div>
																			</v-flex>
																			<v-flex xs1>
																				<v-btn depressed class="red--text" :loading="loading && expressionIndex == expression.id" icon @click="deleteExpression(expression)" v-if="$can('expression_archive')">
																					<v-icon> mdi-delete </v-icon>
																				</v-btn>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																	<v-divider class="mt-2"></v-divider>
																	<v-flex xs12 class="mt-1">
																		<v-layout column>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Principal Founder</b>
																				</div>
																				<div>
																					{{ expression.first_name }} {{ expression.middle_name }} {{ expression.last_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Venture</b>
																				</div>
																				<div>
																					{{ expression.startup_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Age</b>
																				</div>
																				<div v-if="expression.age_group">
																					{{ expression.age_group.name }}
																				</div>
																				<div v-else>
																					N/A
																				</div>
																			</v-flex>
                                                                            <v-flex xs12 class="mt-1">
																				<div>
																					<b>Email</b>
																				</div>
																				<div>
																					{{ expression.email }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Date Added</b>
																				</div>
																				<div>
																					{{
																						expression.created_at
																						| moment("DD/MM/YYYY - hh:mm a")
																					}}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-5">
																				<v-layout row wrap>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn
																								
																								depressed class="
																								primary
																								text-none
																								white--text
																								" block @click="showExpression(expression)">View
																								<v-icon right> mdi-eye
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<!-- <v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="blue text-none white--text"
																								block
																								@click="editExpression(expression)"
																								v-if="$can('expression_edit')">Edit
																								<v-icon right>
																									mdi-border-color
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex> -->
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="green text-none white--text"
																								block
																								@click="expressionReview(expression, 'shortlisted', 'up')"
																								:loading="upgradeLoading && expressionIndex == expression.id"
																								>Shortlist Expression
																								<v-icon right>
																									mdi-arrow-right
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="red text-none white--text"
																								block
																								@click="expressionReview(expression, 'rejectedStage', 'down')"
																								:loading="downgradeLoading && expressionIndex == expression.id"
																								>Reject Expression
																								<v-icon right>
																									mdi-cancel
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn v-if="$can('log_view')"
																								depressed class="
                                                                                                purple
                                                                                                text-none
                                                                                                white--text
                                                                                                " block @click="viewLog(expression)">Log
																								<v-icon right>
																									mdi-script-text
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																				</v-layout>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																</v-layout>
															</div>
														</v-card>
													</v-flex>
												</div>
											</template>
										</v-layout>
									</div>
								</div>
							</v-flex>
						</v-card>

						<v-layout column class="mt-5">
							<v-flex xs12>
								<div align="center">
									<v-pagination v-if="length != 0" :length="reviewExpressionLength" total-visible="10"
										v-model="reviewExpressionPagination.current_page" @input="changeReviewExpressionPage()" circle>
									</v-pagination>
								</div>
							</v-flex>
							<v-flex xs12>
								<div v-if="length != 0" align="center" class="mt-5">
									<b class="primary--text">Total: </b>{{ reviewExpressionPagination.total | formatNumber }}
								</div>
							</v-flex>
						</v-layout>
					</div>
					<div v-if="activeTab == 'rejected'">
						<v-card outlined class="mt-5 pa-3" style="border-radius: 25px;">
							<v-flex xs12 class="mt-10 mb-2">
								<div class="mx-5">
									<v-layout row wrap>
										<v-flex xs12 md4>
											<h1>Rejected Expressions</h1>
										</v-flex>
										<v-flex xs12 md4>
											<div class="pa-1">
												<v-text-field class="text_field header" outlined dense label="Search"
													append-icon="mdi-undo-variant" @click:append="resetSearch()"
													v-on:keyup.enter="rejectedSearch" v-model="searchTerm"
													@input="enableSearch()"></v-text-field>
											</div>

										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="secondary white--text text-none" depressed block
													@click="rejectedSearch" :loading="searchLoader"
													:disabled="searchButtonDisabled">
													Search
													<v-icon right>mdi-magnify</v-icon>
												</v-btn>
											</div>
										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="primary white--text text-none" depressed block
													@click="csvDownload('rejectedExpressions')" :loading="csvLoading">
													Download CSV
													<v-icon right>mdi-microsoft-excel</v-icon>
												</v-btn>												
											</div>
										</v-flex>
									</v-layout>
								</div>
							</v-flex>
							<div class="mx-5 mt-9">
								<v-progress-linear v-if="rejectedExpressionLoader" height="1" indeterminate
									color="primary"></v-progress-linear>
							</div>
							<v-divider class="mx-5"></v-divider>
							<v-flex xs12 class="mt-5">
								<div v-if="rejectedExpressions.length == 0">
									<v-card elevation="0">
										<v-layout row wrap>
											<v-flex xs12 md1>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center">
															<v-icon large class="primary--text">
																mdi-alert-circle-outline
															</v-icon>
														</v-col>
													</v-row>
												</v-container>
											</v-flex>
											<v-flex xs12 md11>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center"> No Expression Found </v-col>
													</v-row>
												</v-container>
											</v-flex>
										</v-layout>
									</v-card>
								</div>
								<div v-else>
									<div class="hidden-sm-and-down">
										<v-card elevation="0" class="pa-2">
											<v-simple-table>
												<template v-slot:default>
													<thead class="header">
														<tr class="tableHeader">
															<th class="text-left text--text">#</th>
															<th class="text-left text--text">Principal Founder</th>
															<th class="text-left text--text">Venture</th>
															<th class="text-left text--text">Age</th>
                                                            <th class="text-left text--text">Email</th>
															<th class="text-left text--text">Date Added</th>
															<th class="text-right text--text">Actions</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(item, index) in rejectedExpressions" :key="item.id">
															<td>
																{{ index + 1 }}
															</td>
															<td>{{ item.first_name }} {{ item.middle_name }} {{ item.last_name }}</td>
															<td>{{ item.startup_name }}</td>
															<td>
																<div v-if="item.age_group">
																	{{ item.age_group.name }}
																</div>
																<div v-else>
																	N/A
																</div>
															</td>
                                                            <td>{{ item.email }}</td>
															<td>
																{{ item.created_at | moment("DD/MM/YYYY - hh:mm a") }}
															</td>
															<td>
																<div align="right">
																	<v-tooltip top >
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 universal--text"
																				@click="showExpression(item)">
																				<v-icon small> mdi-eye </v-icon>
																			</v-btn>
																		</template>
																		<span>View</span>
																	</v-tooltip>
																	<!-- <v-tooltip top v-if="$can('expression_edit')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 success--text"
																				@click="editExpression(item)" v-bind="attrs"
																				v-on="on">
																				<v-icon small> mdi-pencil </v-icon>
																			</v-btn>
																		</template>
																		<span>Edit</span>
																	</v-tooltip> -->

																	<v-tooltip top v-if="$can('expression_archive')">
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 error--text"
																				@click="deleteExpression(item)"
																				:loading="loading && expressionIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-delete </v-icon>
																			</v-btn>
																		</template>
																		<span>delete</span>
																	</v-tooltip>

																	<v-tooltip top
																		>

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 red--text"
																				@click="expressionReview(item, 'reviewStage', 'down')"
																				:loading="downgradeLoading && expressionIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-arrow-left
																				</v-icon>
																			</v-btn>
																		</template>
																		<span>Send Back to Review</span>
																	</v-tooltip>
																	<v-tooltip top
																		>

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 green--text"
																				@click="expressionReview(item, 'shortlisted', 'up')"
																				:loading="upgradeLoading && expressionIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-arrow-right
																				</v-icon>
																			</v-btn>
																		</template>
																		<span>Shortlist Expression</span>
																	</v-tooltip>
																	<v-tooltip top v-if="$can('log_view')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 purple--text"
																				@click="viewLog(item)" v-bind="attrs"
																				v-on="on">
																				<v-icon small> mdi-script-text </v-icon>
																			</v-btn>
																		</template>
																		<span>Log</span>
																	</v-tooltip>

																</div>
															</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>

									</div>
									<div class="hidden-md-and-up">
										<v-layout column>

											<template v-for="(expression, index) in rejectedExpressions">
												<div :key="index">
													<v-flex xs12 class="mb-2">
														<v-card elevation="0">
															<div class="pa-5">
																<v-layout column>
																	<v-flex xs12>
																		<v-layout row wrap>
																			<v-flex xs11>
																				<div class="title primary--text ml-3">
																					<b>{{ expression.startup_name }} </b>
																				</div>
																			</v-flex>
																			<v-flex xs1>
																				<v-btn depressed class="red--text" :loading="loading && expressionIndex == expression.id" icon @click="deleteExpression(expression)" v-if="$can('expression_archive')">
																					<v-icon> mdi-delete </v-icon>
																				</v-btn>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																	<v-divider class="mt-2"></v-divider>
																	<v-flex xs12 class="mt-1">
																		<v-layout column>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Principal Founder</b>
																				</div>
																				<div>
																					{{ expression.first_name }} {{ expression.middle_name }} {{ expression.last_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Venture</b>
																				</div>
																				<div>
																					{{ expression.startup_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Age</b>
																				</div>
																				<div v-if="expression.age_group">
																					{{ expression.age_group.name }}
																				</div>
																				<div v-else>
																					N/A
																				</div>
																			</v-flex>
                                                                            <v-flex xs12 class="mt-1">
																				<div>
																					<b>Email</b>
																				</div>
																				<div>
																					{{ expression.email }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Date Added</b>
																				</div>
																				<div>
																					{{
																						expression.created_at
																						| moment("DD/MM/YYYY - hh:mm a")
																					}}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-5">
																				<v-layout row wrap>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn
																								
																								depressed class="
																								primary
																								text-none
																								white--text
																								" block @click="showExpression(expression)">View
																								<v-icon right> mdi-eye
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<!-- <v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="blue text-none white--text"
																								block
																								@click="editExpression(expression)"
																								v-if="$can('expression_edit')">Edit
																								<v-icon right>
																									mdi-border-color
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex> -->
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="red text-none white--text"
																								block
																								@click="expressionReview(expression, 'reviewStage', 'down')"
																								:loading="downgradeLoading && expressionIndex == expression.id"
																								>Send Back to Review
																								<v-icon right>
																									mdi-arrow-left
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="green text-none white--text"
																								block
																								@click="expressionReview(expression, 'shortlisted', 'up')"
																								:loading="upgradeLoading && expressionIndex == expression.id"
																								>Shortlist Expression
																								<v-icon right>
																									mdi-arrow-right
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn v-if="$can('log_view')"
																								depressed class="
																									purple
																									text-none
																									white--text
																									" block @click="viewLog(expression)">Log
																								<v-icon right>
																									mdi-script-text
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																				</v-layout>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																</v-layout>
															</div>
														</v-card>
													</v-flex>
												</div>
											</template>
										</v-layout>
									</div>
								</div>
							</v-flex>
						</v-card>

						<v-layout column class="mt-5">
							<v-flex xs12>
								<div align="center">
									<v-pagination v-if="length != 0" :length="rejectedExpressionLength" total-visible="10"
										v-model="rejectedExpressionPagination.current_page" @input="changeRejectedExpressionPage()" circle>
									</v-pagination>
								</div>
							</v-flex>
							<v-flex xs12>
								<div v-if="length != 0" align="center" class="mt-5">
									<b class="primary--text">Total: </b>{{ rejectedExpressionPagination.total | formatNumber }}
								</div>
							</v-flex>
						</v-layout>
					</div>
					<div v-if="activeTab == 'shortlisted'">
						<v-card outlined class="mt-5 pa-3" style="border-radius: 25px;">
							<v-flex xs12 class="mt-10 mb-2">
								<div class="mx-5">
									<v-layout row wrap>
										<v-flex xs12 md4>
											<h1>Shortlisted Expressions</h1>
										</v-flex>
										<v-flex xs12 md4>
											<div class="pa-1">
												<v-text-field class="text_field header" outlined dense label="Search"
													append-icon="mdi-undo-variant" @click:append="resetSearch()"
													v-on:keyup.enter="shortlistedSearch" v-model="searchTerm"
													@input="enableSearch()"></v-text-field>
											</div>

										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="secondary white--text text-none" depressed block
													@click="shortlistedSearch" :loading="searchLoader"
													:disabled="searchButtonDisabled">
													Search
													<v-icon right>mdi-magnify</v-icon>
												</v-btn>
											</div>
										</v-flex>
										<v-flex xs12 md2>
											<div class="pa-1">
												<v-btn class="primary white--text text-none" depressed block
													@click="csvDownload('shortlistedExpressions')" :loading="csvLoading">
													Download CSV
													<v-icon right>mdi-microsoft-excel</v-icon>
												</v-btn>
											</div>
										</v-flex>
									</v-layout>
								</div>
							</v-flex>
							<div class="mx-5 mt-9">
								<v-progress-linear v-if="shortlistedExpressionLoader" height="1" indeterminate color="primary"></v-progress-linear>
							</div>
							<v-divider class="mx-5"></v-divider>
							<v-flex xs12 class="mt-5">
								<div v-if="shortlistedExpressions.length == 0">
									<v-card elevation="0">
										<v-layout row wrap>
											<v-flex xs12 md1>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center">
															<v-icon large class="primary--text">
																mdi-alert-circle-outline
															</v-icon>
														</v-col>
													</v-row>
												</v-container>
											</v-flex>
											<v-flex xs12 md11>
												<v-container fill-height fluid>
													<v-row align="center" justify="center">
														<v-col class="text-center"> No Expression Found </v-col>
													</v-row>
												</v-container>
											</v-flex>
										</v-layout>
									</v-card>
								</div>
								<div v-else>
									<div class="hidden-sm-and-down">
										<v-card elevation="0" class="pa-2">
											<v-simple-table>
												<template v-slot:default>
													<thead class="header">
														<tr class="tableHeader">
															<th class="text-left text--text">#</th>
															<th class="text-left text--text">Principal Founder</th>
															<th class="text-left text--text">Venture</th>
															<th class="text-left text--text">Age</th>
                                                            <th class="text-left text--text">Email</th>
															<th class="text-left text--text">Date Added</th>
															<th class="text-right text--text">Actions</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(item, index) in shortlistedExpressions" :key="item.id">
															<td>
																{{ index + 1 }}
															</td>
															<td>{{ item.first_name }} {{ item.middle_name }} {{ item.last_name }}</td>
															<td>{{ item.startup_name }}</td>
															<td>
																<div v-if="item.age_group">
																	{{ item.age_group.name }}
																</div>
																<div v-else>
																	N/A
																</div>
															</td>
                                                            <td>{{ item.email }}</td>
															<td>
																{{ item.created_at | moment("DD/MM/YYYY - hh:mm a") }}
															</td>
															<td>
																<div align="right">
																	<v-tooltip top >
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 universal--text"
																				@click="showExpression(item)">
																				<v-icon small> mdi-eye </v-icon>
																			</v-btn>
																		</template>
																		<span>View</span>
																	</v-tooltip>
																	<!-- <v-tooltip top v-if="$can('expression_edit')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 success--text"
																				@click="editExpression(item)" v-bind="attrs"
																				v-on="on">
																				<v-icon small> mdi-pencil </v-icon>
																			</v-btn>
																		</template>
																		<span>Edit</span>
																	</v-tooltip> -->

																	<v-tooltip top v-if="$can('expression_archive')">
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 error--text"
																				@click="deleteExpression(item)"
																				:loading="loading && expressionIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-delete </v-icon>
																			</v-btn>
																		</template>
																		<span>delete</span>
																	</v-tooltip>

																	<v-tooltip top
																		>

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 red--text"
																				@click="expressionReview(item, 'reviewStage', 'down')"
																				:loading="downgradeLoading && expressionIndex == item.id"
																				v-bind="attrs" v-on="on">
																				<v-icon small> mdi-arrow-left
																				</v-icon>
																			</v-btn>
																		</template>
																		<span>Send Back to Review</span>
																	</v-tooltip>
																	<v-tooltip top v-if="$can('log_view')">

																		<template v-slot:activator="{ on, attrs }">
																			<v-btn icon class="button mr-1 purple--text"
																				@click="viewLog(item)" v-bind="attrs"
																				v-on="on">
																				<v-icon small> mdi-script-text </v-icon>
																			</v-btn>
																		</template>
																		<span>Log</span>
																	</v-tooltip>

																</div>
															</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>

									</div>
									<div class="hidden-md-and-up">
										<v-layout column>

											<template v-for="(expression, index) in shortlistedExpressions">
												<div :key="index">
													<v-flex xs12 class="mb-2">
														<v-card elevation="0">
															<div class="pa-5">
																<v-layout column>
																	<v-flex xs12>
																		<v-layout row wrap>
																			<v-flex xs11>
																				<div class="title primary--text ml-3">
																					<b>{{ expression.startup_name }} </b>
																				</div>
																			</v-flex>
																			<v-flex xs1>
																				<v-btn depressed class="red--text" :loading="loading && expressionIndex == expression.id" icon @click="deleteExpression(expression)" v-if="$can('expression_archive')">
																					<v-icon> mdi-delete </v-icon>
																				</v-btn>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																	<v-divider class="mt-2"></v-divider>
																	<v-flex xs12 class="mt-1">
																		<v-layout column>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Principal Founder</b>
																				</div>
																				<div>
																					{{ expression.first_name }} {{ expression.middle_name }} {{ expression.last_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Venture</b>
																				</div>
																				<div>
																					{{ expression.startup_name }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Age</b>
																				</div>
																				<div v-if="expression.age_group">
																					{{ expression.age_group.name }}
																				</div>
																				<div v-else>
																					N/A
																				</div>
																			</v-flex>
                                                                            <v-flex xs12 class="mt-1">
																				<div>
																					<b>Email</b>
																				</div>
																				<div>
																					{{ expression.email }}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-1">
																				<div>
																					<b>Date Added</b>
																				</div>
																				<div>
																					{{
																						expression.created_at
																						| moment("DD/MM/YYYY - hh:mm a")
																					}}
																				</div>
																			</v-flex>
																			<v-flex xs12 class="mt-5">
																				<v-layout row wrap>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn																								
																								depressed class="
																								primary
																								text-none
																								white--text
																								" block @click="showExpression(expression)">View
																								<v-icon right> mdi-eye
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<!-- <v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="blue text-none white--text"
																								block
																								@click="editExpression(expression)"
																								v-if="$can('expression_edit')">Edit
																								<v-icon right>
																									mdi-border-color
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex> -->
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn depressed
																								class="red text-none white--text"
																								block
																								@click="expressionReview(expression, 'reviewStage', 'down')"
																								:loading="downgradeLoading && expressionIndex == expression.id"
																								>Send Back to Review
																								<v-icon right>
																									mdi-arrow-left
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																					<v-flex xs12>
																						<div class="pa-1">
																							<v-btn v-if="$can('log_view')"
																								depressed class="
																								purple
																								text-none
																								white--text
																								" block @click="viewLog(expression)">Log
																								<v-icon right>
																									mdi-script-text
																								</v-icon>
																							</v-btn>
																						</div>
																					</v-flex>
																				</v-layout>
																			</v-flex>
																		</v-layout>
																	</v-flex>
																</v-layout>
															</div>
														</v-card>
													</v-flex>
												</div>
											</template>
										</v-layout>
									</div>
								</div>
							</v-flex>
						</v-card>

						<v-layout column class="mt-5">
							<v-flex xs12>
								<div align="center">
									<v-pagination v-if="length != 0" :length="shortlistedExpressionLength" total-visible="10"
										v-model="shortlistedExpressionPagination.current_page" @input="changeShortlistedExpressionPage()" circle>
									</v-pagination>
								</div>
							</v-flex>
							<v-flex xs12>
								<div v-if="length != 0" align="center" class="mt-5">
									<b class="primary--text">Total: </b>{{ shortlistedExpressionPagination.total | formatNumber }}
								</div>
							</v-flex>
						</v-layout>
					</div>
				</div>
	
				<div v-if="view == 'show'">
					<v-card outlined class="mt-5">
						<v-card-title class="tableHeader text--text">
							{{ assignedExpression.first_name }} {{ assignedExpression.middle_name }} {{ assignedExpression.last_name }} - {{ assignedExpression.startup_name }}
							<v-spacer></v-spacer>
							<v-btn icon @click="changeView('default')">
								<v-icon class="text--text"> mdi-close </v-icon>
							</v-btn>
						</v-card-title>
						<v-card-text>
							<div class="mt-2">
								<v-tabs show-arrows v-model="applicantTab">
									<v-tabs-slider color="primary"></v-tabs-slider>

									<v-tab @click="subTab = 'principalFounder'">
										<div class="text-none primary--text">Principal Founder</div>
									</v-tab>
									<v-tab @click="subTab = 'venture'">
										<div class="text-none primary--text">
											Venture
										</div>
									</v-tab>
								</v-tabs>
								<div v-if="subTab == 'principalFounder'" class="mx-3">
									<div class="pa-5">
										<v-layout row wrap>
											<v-flex xs12 md6>
												<v-layout column>
													<v-flex xs12 class="mt-7">
														<v-layout row wrap>
															<v-flex xs12 md3>
																<div><b>Name:</b></div>
															</v-flex>
															<v-flex xs12 md9>
																{{ assignedExpression.first_name }} {{ assignedExpression.middle_name }} {{ assignedExpression.last_name }}
															</v-flex>
														</v-layout>
													</v-flex>
													<v-flex xs12 class="mt-7">
														<v-layout row wrap>
															<v-flex xs12 md3>
																<div><b>Email Address:</b></div>
															</v-flex>
															<v-flex xs12 md9>
																{{ assignedExpression.email }}
															</v-flex>
														</v-layout>
													</v-flex>
													<v-flex xs12 class="mt-7">
														<v-layout row wrap>
															<v-flex xs12 md3>
																<div><b>Phone Number:</b></div>
															</v-flex>
															<v-flex xs12 md9>
																{{ assignedExpression.phone }}
															</v-flex>
														</v-layout>
													</v-flex>
													<v-flex xs12 class="mt-7">
														<v-layout row wrap>
															<v-flex xs12 md3>
																<div><b>Age:</b></div>
															</v-flex>
															<v-flex xs12 md9>
																<div v-if="assignedExpression.age_group">
																	{{ assignedExpression.age_group.name }}
																</div>
																<div v-else>
																	N/A
																</div>
															</v-flex>
														</v-layout>
													</v-flex>
												</v-layout>
											</v-flex>
											<v-flex xs12 md6>
												<v-layout column>
													<v-flex xs12 class="mt-7">
														<v-layout row wrap>
															<v-flex xs12 md3>
																<div><b>Nationality:</b></div>
															</v-flex>
															<v-flex xs12 md9>
																{{ assignedExpression.country.name }}
															</v-flex>
														</v-layout>
													</v-flex>
													<v-flex xs12 class="mt-7">
														<v-layout row wrap>
															<v-flex xs12 md3>
																<div><b>City/Town of Residence:</b></div>
															</v-flex>
															<v-flex xs12 md9>
																{{ assignedExpression.city.name }}
															</v-flex>
														</v-layout>
													</v-flex>
													<v-flex xs12 class="mt-7">
														<v-layout row wrap>
															<v-flex xs12 md3>
																<div><b>PWD:</b></div>
															</v-flex>
															<v-flex xs12 md9>
																<div v-if="assignedExpression.pwd == 1">
																	Yes
																</div>
																<div v-else>
																	No
																</div>
															</v-flex>
														</v-layout>
													</v-flex>
												</v-layout>
											</v-flex>
										</v-layout>										
									</div>									
								</div>
								<div v-if="subTab == 'venture'" class="mx-3">
									<div class="pa-5">
										<v-layout row wrap>
											<v-flex xs12 md6>
												<v-layout column>
													<v-flex xs12 class="mt-7">
														<v-layout row wrap>
															<v-flex xs12 md3>
																<div><b>Name:</b></div>
															</v-flex>
															<v-flex xs12 md9>
																{{ assignedExpression.startup_name }}
															</v-flex>
														</v-layout>
													</v-flex>
													<v-flex xs12 class="mt-7">
														<v-layout row wrap>
															<v-flex xs12 md3>
																<div><b>Country of Operation:</b></div>
															</v-flex>
															<v-flex xs12 md9>
																{{ assignedExpression.operation_country.name }}
															</v-flex>
														</v-layout>
													</v-flex>
													<v-flex xs12 class="mt-7">
														<v-layout row wrap>
															<v-flex xs12 md3>
																<div><b>Stage:</b></div>
															</v-flex>
															<v-flex xs12 md9>
																{{ assignedExpression.stage.name }}
															</v-flex>
														</v-layout>
													</v-flex>
												</v-layout>
											</v-flex>
											<v-flex xs12 md6>
												<v-layout column>
													<v-flex xs12 class="mt-7">
														<v-layout row wrap>
															<v-flex xs12 md3>
																<div><b>Established:</b></div>
															</v-flex>
															<v-flex xs12 md9>
																<div v-if="assignedExpression.year_established != null">
																	{{ assignedExpression.year_established }}
																</div>
																<div v-else>
																	N/A
																</div>
															</v-flex>
														</v-layout>
													</v-flex>
													<v-flex xs12 class="mt-7">
														<v-layout row wrap>
															<v-flex xs12 md3>
																<div><b>Number of startup team members:</b></div>
															</v-flex>
															<v-flex xs12 md9>
																{{ assignedExpression.team_member.name }}
															</v-flex>
														</v-layout>														
													</v-flex>
													<v-flex xs12 class="mt-7">
														<v-layout row wrap>
															<v-flex xs12 md3>
																<div><b>Annual revenue generated in 2025 in KES:</b></div>
															</v-flex>
															<v-flex xs12 md9>
																{{ assignedExpression.revenue_range.name }}
															</v-flex>
														</v-layout>														
													</v-flex>
												</v-layout>
											</v-flex>
											<v-flex xs12 md6>
												<v-layout column>
													<v-flex xs12 class="mt-10">
														<v-layout row wrap>
															<v-flex xs12 md3>
																<div><b>Sectors:</b></div>
															</v-flex>
															<v-flex xs12 md9>
																<v-layout column>
																	<template v-for="(sector, index) in assignedExpression.sectors">
																		<v-flex xs12>
																			{{ index+1 }}. {{ sector.name }}
																		</v-flex>
																	</template>
																</v-layout>
															</v-flex>
														</v-layout>
													</v-flex>
												</v-layout>
											</v-flex>
											<v-flex xs12>
												<div class="mt-8 mb-5 mx-16">
													<v-divider></v-divider>
												</div>
											</v-flex>
											<v-flex xs12 class="mt-5">
												<v-layout row wrap>
													<v-flex xs12>
														<div><b>Solution Description</b></div>
													</v-flex>
												</v-layout>														
											</v-flex>
											<v-flex xs12>
												<v-layout column>
													<v-flex xs12 class="mt-7">
														<v-layout row wrap>
															<v-flex xs12>
																<div v-html="assignedExpression.description"> </div>
															</v-flex>
														</v-layout>
													</v-flex>
												</v-layout>
											</v-flex>
										</v-layout>												
									</div>
								</div>
							</div>
						</v-card-text>
					</v-card>
				</div>
			</v-layout>
		</v-container>
		<logData v-if="logDataModel" v-model="logDataModel" />
	</div>
</template>

<script>
import apiCall from "@/utils/api";
import { mapGetters, mapActions } from "vuex";
import logData from "@/views/accessControl/logData";
import Vue from "vue";
import pdf from 'vue-pdf'
var numeral = require("numeral");
Vue.filter("formatNumber", function (value) {
	return numeral(value).format("0,0");
});

Vue.use(require("vue-moment"));

export default {
	components: {
		logData,
		pdf
	},
	data() {
		return {
			path: process.env.VUE_APP_API_URL,
			view: "default",
			activeTab: 'submitted',
			subTab: 'principalFounder',
			expressionTab: null,
			applicantTab: null,

			pdfsrc: null,
      		pageCount: 0,

			documentPath: null,
			docType: null,
			pdfViewDialog: false,

			loading: false,
			upgradeLoading: false,
			downgradeLoading: false,
			rejectLoading: false,
			deactivateLoading: false,

			csvLoading: false,
			pdfLoading: false,

			albumLoader: false,
			imageLoader: false,

			albumDatePicker: false,

			valid: true,
			message: "",
			color: "",
			delete: false,
			activate: false,
			confirm: false,
			lockEmail: false,

			expressionIndex: null,
			albumIndex: null,

			snackbar: false,
			inputRules: [
				(v) => !!v || "Input is required"
			],
			fileRules: [(v) => !!v || "Kindly Select a File"],

			imageDialog: false,
			imageLink: '',
			imageName: "",
			imageUrl: "",
			imageFile: "",
			imageValid: true,
			imageLoading: false,

			months: [
				"01",
				"02",
				"03",
				"04",
				"05",
				"06",
				"07",
				"08",
				"09",
				"10",
				"11",
				"12",
			],

			images: [],

			openEnded: [],
			singleSelect: [],
			multiPartSingleAnswers: [],
			multiPartMultiAnswers: [],
			multiSelects: [],
			questions: [],

			otherQuestions: [],
			childQuestions: [],
			counter: 0,

			searchTerm: null,
			searchLoader: false,
			searchButtonDisabled: false,

			filteredSubmittedExpressions: false,
			filteredReviewExpressions: false,
			filteredRejectedExpressions: false,
			filteredShortlistedExpressions: false,

			newExpression: {
				id: null,
				name: null,
			},

			assignedExpression: null,

			formData: null,
			logData: {
				message: null,
				model: "App\\Models\\Expression",
			},
		};
	},
	created() {
		if (this.$can("expression_view")) {
			this.startSubmittedExpressionLoader();
			this.fetchSubmittedExpressions(this.submittedExpressionPagination.current_page);

			this.startReviewExpressionLoader();
			this.fetchReviewExpressions(this.reviewExpressionPagination.current_page);

			this.startRejectedExpressionLoader();
			this.fetchRejectedExpressions(this.rejectedExpressionPagination.current_page);

			this.startShortlistedExpressionLoader();
			this.fetchShortlistedExpressions(this.shortlistedExpressionPagination.current_page);
			
			this.getQuestions();
			this.getFormData()
		}
	},
	methods: {
		...mapActions([
			"fetchSubmittedExpressions",
			"startSubmittedExpressionLoader",
			"stopSubmittedExpressionLoader",
			"filterSubmittedExpressions",

			"fetchReviewExpressions",
			"startReviewExpressionLoader",
			"stopReviewExpressionLoader",
			"filterReviewExpressions",

			"fetchRejectedExpressions",
			"startRejectedExpressionLoader",
			"stopRejectedExpressionLoader",
			"filterRejectedExpressions",

			"fetchShortlistedExpressions",
			"startShortlistedExpressionLoader",
			"stopShortlistedExpressionLoader",
			"filterShortlistedExpressions",

			"filterLogData",
			"openLogDataModel",
		]),

		showExpression(expression) {
			this.assignedExpression = expression;
			this.changeView("show");			
		},

		enableSearch() {
			this.searchButtonDisabled = false;
		},

		resetSubmittedSearch() {
			this.searchTerm = null;
			this.filteredSubmittedExpressions = true;
			this.startSubmittedExpressionLoader();
			this.fetchSubmittedExpressions(1);
		},
		resetReviewSearch() {
			this.searchTerm = null;
			this.filteredReviewExpressions = true;
			this.startReviewExpressionLoader();
			this.fetchReviewExpressions(1);
		},
		resetRejectedSearch() {
			this.searchTerm = null;
			this.filteredRejectedExpressions = true;
			this.startRejectedExpressionLoader();
			this.fetchRejectedExpressions(1);
		},
		resetShortlistedSearch() {
			this.searchTerm = null;
			this.filteredShortlistedExpressions = true;
			this.startShortlistedExpressionLoader();
			this.fetchShortlistedExpressions(1);
		},
		

		viewLog(data) {
			this.logData.message = data.id;
			this.filterLogData(this.logData);
			this.openLogDataModel();
		},

		csvDownload(type) {
            this.csvLoading = true;
            apiCall({
                url: "/api/report?type="+type,
                method: "GET",
            })
                .then((resp) => {
                    this.csvLoading = false;
                    this.downloadFile(resp, type);
                })
                .catch((error) => {
                    console.log(error.response);
                    this.csvLoading = false;
                    this.message = "An Error Occurred";
                    this.color = "error";
                    this.snackbar = true;
                });
        },

		downloadFile(response, type) {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([response], { type: "expression/csv" });

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob);
                return;
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement("a");
            link.href = data;
			if(type=='submittedExpressions'){
				link.download = 'Submitted Expressions - '  + this.dateToday +  ".csv";
			}
			if(type=='reviewExpressions'){
				link.download = 'Review Expressions - '  + this.dateToday +  ".csv";
			}
			if(type=='rejectedExpressions'){
				link.download = 'Rejected Expressions - '  + this.dateToday +  ".csv";
			}
			if(type=='shortlistedExpressions'){
				link.download = 'Shortlisted Expressions - '  + this.dateToday +  ".csv";
			}
            
            link.click();
            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
            }, 100);
        },

		pdfDownload() {
            this.pdfLoading = true;

            axios.defaults.headers.common['Authorization'] = localStorage.getItem('user-token');
            axios({
                url: this.path+"/api/report?type=expressionPDF",
                data: this.assignedExpression,
                method: "POST",
                responseType: "blob",
            })
                    .then((resp) => {
                        this.downloadPDFFile(resp, this.assignedExpression.startup_name);
                        this.pdfLoading = false;
                    })
                    .catch((error) => {
                        this.pdfLoading = false;
                    });
        },
		downloadPDFFile(response, filename) {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            console.log('response.data', response.data)
            var newBlob = new Blob([response.data], { type: "expression/pdf" });

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob);
                return;
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement("a");
            link.href = data;
            link.download = filename + ' ' + this.dateToday + ".pdf";
            link.click();
            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
            }, 100);
        },



		submittedSearch() {
			if (this.searchTerm == null) {
				this.searchButtonDisabled = true;
			} else {
				this.searchLoader = true;
				this.searchButtonDisabled = false;
				this.startSubmittedExpressionLoader();
				apiCall({
					url: "/api/expression?type=submittedSearch&search=" + this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterSubmittedExpressions(resp);
						this.searchLoader = false;
						this.stopSubmittedExpressionLoader();
						this.filteredSubmittedExpressions = true;
					})
					.catch((error) => {
						console.log(error.response);
						this.searchLoader = false;
						this.stopSubmittedExpressionLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			}
		},
		reviewSearch() {
			if (this.searchTerm == null) {
				this.searchButtonDisabled = true;
			} else {
				this.searchLoader = true;
				this.searchButtonDisabled = false;
				this.startReviewExpressionLoader();
				apiCall({
					url: "/api/expression?type=reviewSearch&search=" + this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterReviewExpressions(resp);
						this.searchLoader = false;
						this.stopReviewExpressionLoader();
						this.filteredReviewExpressions = true;
					})
					.catch((error) => {
						console.log(error.response);
						this.searchLoader = false;
						this.stopReviewExpressionLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			}
		},
		rejectedSearch() {
			if (this.searchTerm == null) {
				this.searchButtonDisabled = true;
			} else {
				this.searchLoader = true;
				this.searchButtonDisabled = false;
				this.startRejectedExpressionLoader();
				apiCall({
					url: "/api/expression?type=rejectedSearch&search=" + this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterRejectedExpressions(resp);
						this.searchLoader = false;
						this.stopRejectedExpressionLoader();
						this.filteredRejectedExpressions = true;
					})
					.catch((error) => {
						console.log(error.response);
						this.searchLoader = false;
						this.stopRejectedExpressionLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			}
		},
		shortlistedSearch() {
			if (this.searchTerm == null) {
				this.searchButtonDisabled = true;
			} else {
				this.searchLoader = true;
				this.searchButtonDisabled = false;
				this.startShortlistedExpressionLoader();
				apiCall({
					url: "/api/expression?type=shortlistedSearch&search=" + this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterShortlistedExpressions(resp);
						this.searchLoader = false;
						this.stopShortlistedExpressionLoader();
						this.filteredShortlistedExpressions = true;
					})
					.catch((error) => {
						console.log(error.response);
						this.searchLoader = false;
						this.stopShortlistedExpressionLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			}
		},
		
		changeView(view) {
			if (view == "default") {
				
			} else if (view == "create") {
				this.getFormData();
			} else if (view == "show") {
			}
			this.view = view;
		},

		getQuestions() {
			apiCall({
				url: "/api/question?type=public",
				method: "GET",
			})
				.then((resp) => {
					this.questions = resp;
				})
				.catch((error) => {
					this.message = "An Error Occurred; Couldn't Get Form Data";
					this.color = "error";
				});
		},

		changeSubmittedExpressionPage() {
			this.startSubmittedExpressionLoader();
			if (this.filteredSubmittedExpressions == true) {
				this.searchButtonDisabled = false;
				apiCall({
					url:
						"/api/expression?page=" +
						this.submittedExpressionPagination.current_page +
						"&type=search&search=" +
						this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterSubmittedExpressions(resp);
						this.stopSubmittedExpressionLoader();
					})
					.catch((error) => {
						this.stopSubmittedExpressionLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			} else {
				this.fetchSubmittedExpressions(this.submittedExpressionPagination.current_page);
			}
		},
		changeReviewExpressionPage() {
			this.startReviewExpressionLoader();
			if (this.filteredReviewExpressions == true) {
				this.searchButtonDisabled = false;
				apiCall({
					url:
						"/api/expression?page=" +
						this.reviewExpressionPagination.current_page +
						"&type=search&search=" +
						this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterReviewExpressions(resp);
						this.stopReviewExpressionLoader();
					})
					.catch((error) => {
						this.stopReviewExpressionLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			} else {
				this.fetchReviewExpressions(this.reviewExpressionPagination.current_page);
			}
		},
		changeRejectedExpressionPage() {
			this.startRejectedExpressionLoader();
			if (this.filteredRejectedExpressions == true) {
				this.searchButtonDisabled = false;
				apiCall({
					url:
						"/api/expression?page=" +
						this.rejectedExpressionPagination.current_page +
						"&type=search&search=" +
						this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterRejectedExpressions(resp);
						this.stopRejectedExpressionLoader();
					})
					.catch((error) => {
						this.stopRejectedExpressionLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			} else {
				this.fetchRejectedExpressions(this.rejectedExpressionPagination.current_page);
			}
		},
		changeShortlistedExpressionPage() {
			this.startShortlistedExpressionLoader();
			if (this.filteredShortlistedExpressions == true) {
				this.searchButtonDisabled = false;
				apiCall({
					url:
						"/api/expression?page=" +
						this.shortlistedExpressionPagination.current_page +
						"&type=search&search=" +
						this.searchTerm,
					method: "GET",
				})
					.then((resp) => {
						this.filterShortlistedExpressions(resp);
						this.stopShortlistedExpressionLoader();
					})
					.catch((error) => {
						this.stopShortlistedExpressionLoader();
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
					});
			} else {
				this.fetchShortlistedExpressions(this.shortlistedExpressionPagination.current_page);
			}
		},

		deleteExpression(item) {
			confirm("Are You Sure You Want to Delete Expression?") && (this.delete = true);
			if (this.delete) {
				this.loading = true;
				this.expressionIndex = item.id;
				apiCall({ url: "/api/expression/" + item.id, method: "DELETE" })
					.then((resp) => {
						this.message = "Expression Deleted Succesfully";
						this.color = "success";
						this.snackbar = true;
						this.loading = false;
						this.delete = false;
						this.expressionIndex = null;
						this.fetchSubmittedExpressions(this.submittedExpressionPagination.current_page);
					})
					.catch((error) => {
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
						this.loading = false;
						this.delete = false;
						this.expressionIndex = null;
						console.log(error.response);
					});
			}
		},

		expressionReview(item, type, loader) {
			confirm("Please confirm if you would like to advance the expression to the subsequent stage.") && (this.activate = true);
			if (this.activate) {
				if(loader=='up'){
					this.upgradeLoading = true;
				}else if(loader=='down'){
					this.downgradeLoading = true;
				}else if(loader=='downSpec'){
					this.rejectLoading = true;
				}
				
				this.expressionIndex = item.id;
				this.newExpression.id = item.id;
				apiCall({
					url: "/api/expression?type=review&level="+type,
					data: this.newExpression,
					method: "POST"
				})
					.then((resp) => {
						if(type == 'reviewStage'){
							this.message = "Expression Sent to Review Stage";
						}else if(type == 'shortlisted'){
							this.message = "Expression Shortlisted";
						}else if(type == 'rejectedStage'){
							this.message = "Expression Rejected";
						}
						
						if(loader=='up'){
							this.color = "success";
						}else{
							this.color = "orange";
						}
						this.snackbar = true;
						this.upgradeLoading = false;
						this.downgradeLoading = false;
						this.rejectLoading = false;
						this.activate = false;
						this.expressionIndex = null;
						if(type=='reviewStage'){
							if(loader=='up'){
								this.fetchSubmittedExpressions(this.submittedExpressionPagination.current_page);								
							}else{
								this.fetchRejectedExpressions(this.rejectedExpressionPagination.current_page);
								this.fetchShortlistedExpressions(this.shortlistedExpressionPagination.current_page);
							}
							this.fetchReviewExpressions(this.reviewExpressionPagination.current_page);						
						}else if(type=='rejectedStage'){
							if(loader=='up'){
								this.fetchReviewExpressions(this.reviewExpressionPagination.current_page);
							}else{
								this.fetchShortlistedExpressions(this.shortlistedExpressionPagination.current_page);
								this.fetchReviewExpressions(this.reviewExpressionPagination.current_page);
							}							
							this.fetchRejectedExpressions(this.rejectedExpressionPagination.current_page);
						}else if(type=='shortlisted'){
							if(loader=='up'){
								this.fetchReviewExpressions(this.reviewExpressionPagination.current_page);
								this.fetchRejectedExpressions(this.rejectedExpressionPagination.current_page);
							}else{
								this.fetchShortlistedExpressions(this.shortlistedExpressionPagination.current_page);
							}
							this.fetchShortlistedExpressions(this.shortlistedExpressionPagination.current_page);
						}						
					})
					.catch((error) => {
						this.message = "An Error Occurred";
						this.color = "error";
						this.snackbar = true;
						this.upgradeLoading = false;
						this.activate = false;
						this.expressionIndex = null;
						console.log(error.response);
					});
			}
		},
		getFormData() {
			apiCall({
				url: "/api/expression?type=formData",
				method: "GET",
			})
				.then((resp) => {
					this.formData = resp;
				})
				.catch((error) => {
					this.message = "An Error Occurred; Couldn't Get Form Data";
					this.color = "error";
				});
		},
	},
	computed: {
		...mapGetters([
			"submittedExpressions", "submittedExpressionPagination", "submittedExpressionLoader", 
			"reviewExpressions", "reviewExpressionPagination", "reviewExpressionLoader", 
			"rejectedExpressions", "rejectedExpressionPagination", "rejectedExpressionLoader",
			"shortlistedExpressions", "shortlistedExpressionPagination", "shortlistedExpressionLoader", 
			
			"logDataModel"
		]),
		submittedExpressionLength: function () {
			return Math.ceil(
				this.submittedExpressionPagination.total / this.submittedExpressionPagination.per_page
			);
		},
		reviewExpressionLength: function () {
			return Math.ceil(
				this.reviewExpressionPagination.total / this.reviewExpressionPagination.per_page
			);
		},
		rejectedExpressionLength: function () {
			return Math.ceil(
				this.rejectedExpressionPagination.total / this.rejectedExpressionPagination.per_page
			);
		},
		shortlistedExpressionLength: function () {
			return Math.ceil(
				this.shortlistedExpressionPagination.total / this.shortlistedExpressionPagination.per_page
			);
		},
		
		dateToday() {
			var today = new Date();

			var timestamp =
				today.getFullYear() +
				"-" +
				this.months[today.getMonth()] +
				"-" +
				("0" + today.getDate()).slice(-2);
			return timestamp;
		},
	},
};
</script>